// import axios from 'axios';
// import { getToken } from './auth';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_URL_API,
//   // baseURL: 'https://api.barreirafiscal.app',
// });

// api.interceptors.request.use(async config => {
//   const token = getToken();

//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   console.log(config);
//   return config;
// });

// export default api;
import axios from 'axios';
import { getToken, logout } from './auth'; // Você deve criar uma função `removeToken` para limpar o token.
import { toast } from 'react-toastify';
import resolverMensagemErro from '../utils/resolverMensagemErro';

// const api = axios.create();
const api = axios.create({
  baseURL: '/api', // Usar /api para corresponder ao http-proxy-middleware
});

api.interceptors.request.use(async config => {
  const token = getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// [#217] A extracao da mensagem vive em utils/resolverMensagemErro.js. Antes
// havia tres copias da mesma ideia (aqui e nas duas telas de camera), e elas ja
// tinham divergido entre si.

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // Trate a resposta não autorizada (token inválido)
      // Remova o token inválido do armazenamento local
      // Redirecione o usuário para a página de login
      toast.error('Acesso Negado, Identificação gerada');
      logout();
      window.location.href = '/';
      // Ou utilize a navegação do React Router, se aplicável
    } else {
      // Rede de seguranca global: antes disso, uma gravacao recusada pelo
      // backend nao produzia mensagem nenhuma na tela quando a chamada estava
      // sem try/catch — o usuario repetia a operacao sem saber o motivo.
      //
      // So vale para escrita: falha de GET costuma ser carregamento em segundo
      // plano e encheria a tela de toast sem o usuario ter feito nada.
      const metodo = (error.config && error.config.method) || '';
      const ehEscrita = ['post', 'put', 'patch', 'delete'].includes(
        metodo.toLowerCase()
      );

      // Saída explícita para quem JÁ trata o erro na tela. Sem isto, a rede de
      // segurança vira ruído: a chamada que trata localmente mostra dois
      // toasts, e o genérico ("Não foi possível concluir") pode contradizer o
      // específico. Foi o que aconteceu no congelamento de indicadores — o 409
      // de "período já congelado" não é falha, é recusa esperada, e saía em
      // vermelho ao lado da explicação correta.
      //
      // Usar SÓ onde a tela realmente mostra a mensagem ao usuário; caso
      // contrário o erro volta a ser silencioso, que é o que esta rede existe
      // para impedir.
      const silenciado = !!(error.config && error.config.toastNaTela);

      if (ehEscrita && !silenciado) {
        toast.error(`Não foi possível concluir: ${resolverMensagemErro(error)}`);
      }
    }
    // Continua rejeitando: telas que ja tratam o erro localmente seguem
    // funcionando como antes.
    return Promise.reject(error);
  }
);

export default api;
